document.addEventListener("DOMContentLoaded", function () {
  // iOS Safari tespiti
  const isIOSSafari =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/CriOS|FxiOS|OPiOS|mercury/.test(navigator.userAgent);

  // iOS Safari için özel düzeltmeler
  if (isIOSSafari) {
    // iOS Safari'de mobil navigasyon drawer'ı için özel stiller
    const style = document.createElement("style");
    style.textContent = `
      .mobile-navigation-drawer {
        -webkit-overflow-scrolling: touch !important;
        -webkit-transform: translate3d(0, 0, 0) !important;
        transform: translate3d(0, 0, 0) !important;
        backface-visibility: hidden !important;
        perspective: 1000px !important;
      }
      
      body.reveal-mobile-nav .mobile-navigation-drawer {
        -webkit-transform: translate3d(0, 0, 0) !important;
        transform: translate3d(0, 0, 0) !important;
      }
      
      body:not(.reveal-mobile-nav) .mobile-navigation-drawer {
        -webkit-transform: translate3d(-100%, 0, 0) !important;
        transform: translate3d(-100%, 0, 0) !important;
      }
      
      .mobile-navigation-drawer .navigation__tier-2-container {
        -webkit-overflow-scrolling: touch !important;
        -webkit-transform: translate3d(100%, 0, 0) !important;
        transform: translate3d(100%, 0, 0) !important;
      }
      
      .mobile-navigation-drawer .navigation__tier-2-container.navigation__tier-2-container--open {
        -webkit-transform: translate3d(0, 0, 0) !important;
        transform: translate3d(0, 0, 0) !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Mobil navigasyon tab fonksiyonları
  function initMobileNavTabs() {
    const tabButtons = document.querySelectorAll(".mobile-nav-tab-button");
    const tabContents = document.querySelectorAll(".mobile-nav-tab-content");
    const scrollContainers = document.querySelectorAll(
      ".mobile-nav-tabs__scroll-container"
    );

    if (tabButtons.length === 0) return;

    // Scroll göstergesi kontrolü
    function checkScrollOverflow(container) {
      if (container.scrollWidth > container.clientWidth) {
        container.classList.add("has-overflow");
      } else {
        container.classList.remove("has-overflow");
      }
    }

    // Scroll container'ları için overflow kontrolü
    scrollContainers.forEach((container) => {
      checkScrollOverflow(container);

      // Scroll event listener ekle
      container.addEventListener("scroll", function () {
        checkScrollOverflow(this);
      });

      // Resize event listener ekle
      window.addEventListener("resize", function () {
        checkScrollOverflow(container);
      });
    });

    // Alt kategori navigasyonu için event listener'lar
    function initSubcategoryNavigation() {
      const expandableLinks = document.querySelectorAll(
        ".mobile-nav-submenu__link--expandable"
      );
      const backButtons = document.querySelectorAll(
        ".mobile-nav-submenu__link--back"
      );

      // Alt kategoriye tıklama
      expandableLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const parentTab = this.closest(".mobile-nav-tab-content");
          const childIndex = this.getAttribute("data-child-index");
          const parentTabIndex = parentTab.getAttribute("data-tab-index");

          // Ana menüyü gizle
          const mainMenu = parentTab.querySelector(
            `.mobile-nav-submenu--main[data-parent-tab="${parentTabIndex}"]`
          );
          if (mainMenu) {
            mainMenu.style.display = "none";
          }

          // Alt kategori menüsünü göster
          const childMenu = parentTab.querySelector(
            `.mobile-nav-submenu--children[data-parent-tab="${parentTabIndex}"][data-child-index="${childIndex}"]`
          );
          if (childMenu) {
            childMenu.style.display = "block";
          }
        });
      });

      // Geri dön butonları
      backButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();

          const parentTab = this.closest(".mobile-nav-tab-content");
          const parentTabIndex = parentTab.getAttribute("data-tab-index");

          // Tüm alt kategori menülerini gizle
          const childMenus = parentTab.querySelectorAll(
            `.mobile-nav-submenu--children[data-parent-tab="${parentTabIndex}"]`
          );
          childMenus.forEach((menu) => {
            menu.style.display = "none";
          });

          // Ana menüyü göster
          const mainMenu = parentTab.querySelector(
            `.mobile-nav-submenu--main[data-parent-tab="${parentTabIndex}"]`
          );
          if (mainMenu) {
            mainMenu.style.display = "block";
          }
        });
      });
    }

    tabButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const tabIndex = this.getAttribute("data-tab-index");

        // Aktif tab butonunu güncelle
        tabButtons.forEach((btn) =>
          btn.classList.remove("mobile-nav-tab-button--active")
        );
        this.classList.add("mobile-nav-tab-button--active");

        // Aktif tab içeriğini güncelle
        tabContents.forEach((content) => {
          content.classList.remove("mobile-nav-tab-content--active");
          if (content.getAttribute("data-tab-index") === tabIndex) {
            content.classList.add("mobile-nav-tab-content--active");
          }
        });

        // Scroll container'ı aktif tab'a kaydır
        const scrollContainer = this.closest(
          ".mobile-nav-tabs__scroll-container"
        );
        if (scrollContainer) {
          const containerWidth = scrollContainer.offsetWidth;
          const buttonLeft = this.offsetLeft;
          const buttonWidth = this.offsetWidth;
          const scrollLeft = scrollContainer.scrollLeft;

          // Butonun görünür olup olmadığını kontrol et
          if (
            buttonLeft < scrollLeft ||
            buttonLeft + buttonWidth > scrollLeft + containerWidth
          ) {
            scrollContainer.scrollTo({
              left: buttonLeft - containerWidth / 2 + buttonWidth / 2,
              behavior: "smooth",
            });
          }
        }

        // Mobil navigasyon başlığını güncelle
        const navTitle = document.querySelector(".mobile-nav-title");
        if (navTitle) {
          navTitle.textContent = this.getAttribute("data-tab-title");
        }

        // Tab değiştiğinde alt kategori navigasyonunu yeniden başlat
        setTimeout(initSubcategoryNavigation, 50);
      });
    });


    // Alt kategori navigasyonunu başlat
    initSubcategoryNavigation();

    // Touch/swipe desteği ekle
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    scrollContainers.forEach((container) => {
      container.addEventListener("touchstart", function (e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      });

      container.addEventListener("touchmove", function (e) {
        if (!isDragging) return;

        currentX = e.touches[0].clientX;
        const diff = startX - currentX;

        if (Math.abs(diff) > 10) {
          container.scrollLeft += diff;
          startX = currentX;
        }
      });

      container.addEventListener("touchend", function () {
        isDragging = false;
      });
    });
  }

  // Sayfa yüklendiğinde ve mobil navigasyon açıldığında çalıştır
  initMobileNavTabs();

  // Mobil navigasyon açıldığında tab'ları yeniden başlat
  document.addEventListener("mobileNavOpened", function () {
    setTimeout(initMobileNavTabs, 100);
  });

  // MutationObserver ile dinamik içerik değişikliklerini izle
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function (node) {
          if (
            node.nodeType === 1 &&
            node.classList &&
            node.classList.contains("mobile-nav-tabs")
          ) {
            setTimeout(initMobileNavTabs, 50);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
